import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useScrollDirection from 'hooks/useScrollDirection';

const HideOnScroll = forwardRef(
  ({ children, enabled = true, onHideTrigger, listenElementSelector = null }, ref) => {
    const { isHidden, resetVisibility } = useScrollDirection(listenElementSelector);
    const isOnDesktop = useMediaQuery('(min-width: 641px)');

    useImperativeHandle(ref, () => ({
      resetVisibility,
    }));

    useEffect(
      () => {
        if (!onHideTrigger) {
          return;
        }

        onHideTrigger(isHidden);
      },
      [isHidden],
    );

    if (enabled && !isOnDesktop) {
      return (
        <Slide appear={false} direction="down" in={!isHidden}>
          {React.cloneElement(children, {
            style: {
              ...children.props.style,
              transition: 'all 0.3s ease-in-out',
              ...(isHidden && {
                height: '0px',
                padding: '0px',
                overflow: 'hidden',
              }),
            },
          })}
        </Slide>
      );
    }
    return children;
  },
);

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  enabled: PropTypes.bool,
  onHideTrigger: PropTypes.func,
  listenElementSelector: PropTypes.string,
};

export default HideOnScroll;
